export var Residences = [
  {
    id: "L0364",
    name: "Dosentola (Dusentula), de, terre Montisbellii",
    alternatives: [],
  },
  { id: "L0497", name: "Mongiorgio: Valle (Vallis), de", alternatives: [] },
  { id: "L0580", name: "Plumatium (Plumacium)", alternatives: [] },
  { id: "L0630", name: "Rodiiano, de; terra", alternatives: [] },
  { id: "L0647", name: "Samodia", alternatives: [] },
  {
    id: "L0018",
    name: "Bayso (Baisio, Abaysio, Abaixie), de",
    alternatives: [],
  },
  { id: "L0019", name: "Balugola, de, Mutinensis diocesis", alternatives: [] },
  { id: "L0029", name: "Bertalia iuxta Bononiam", alternatives: [] },
  { id: "L0034", name: "Bononia", alternatives: [] },
  { id: "L0041", name: "Burgus Galerii (Galerie, Gallerie)", alternatives: [] },
  { id: "L0049", name: "Burgus S. Felicis", alternatives: [] },
  { id: "L0052", name: "Burgus S. Petri", alternatives: [] },
  { id: "L0059", name: "Cappella S. Agate (Agathe)", alternatives: [] },
  {
    id: "L0066",
    name: "Cappella S. Benedicti burgi Gallerie",
    alternatives: [],
  },
  {
    id: "L0068",
    name: "Cappella S. Bertholi (Bartholi) porte Ravennatis",
    alternatives: [],
  },
  { id: "L0069", name: "Cappella S. Blaxii", alternatives: [] },
  {
    id: "L0070",
    name: "Cappella S. Caterine (Chaterine, Catherine) de porta S. Proculi  (de Sarragocia)",
    alternatives: [],
  },
  { id: "L0071", name: "Cappella S. Cecilie", alternatives: [] },
  { id: "L0077", name: "Capella S. Crucis", alternatives: [] },
  { id: "L0078", name: "Capella S. Damiani", alternatives: [] },
  { id: "L0080", name: "Cappella S. Donati", alternatives: [] },
  { id: "L0081", name: "Cappella S. Egidii (Gilii)", alternatives: [] },
  {
    id: "L0084",
    name: "Cappella S. Georgii (Çeorçii) de Poçale",
    alternatives: [],
  },
  {
    id: "L0085",
    name: "Cappella S. Iacobi de Carbonensibus",
    alternatives: [],
  },
  { id: "L0087", name: "Cappella S. Iohannis in Monte", alternatives: [] },
  { id: "L0088", name: "Cappella S. Iosep", alternatives: [] },
  { id: "L0089", name: "Cappella S. Ypoliti", alternatives: [] },
  { id: "L0093", name: "Cappella S. Laurentii porte Steri", alternatives: [] },
  { id: "L0094", name: "Cappella S. Leonardi", alternatives: [] },
  { id: "L0096", name: "Capella S. Mammi (Mami)", alternatives: [] },
  { id: "L0097", name: "Cappella S. Marie", alternatives: [] },
  { id: "L0099", name: "Cappella S. Marie de Bulgaris", alternatives: [] },
  {
    id: "L0102",
    name: "Cappella S. Marie de Castrobritonum",
    alternatives: [],
  },
  {
    id: "L0105",
    name: "Cappella S. Marie de Guidoschalchis",
    alternatives: [],
  },
  {
    id: "L0106",
    name: "Cappella S. Marie Magdalene de strata S. Donati",
    alternatives: [],
  },
  { id: "L0107", name: "Cappella S. Marie Maioris", alternatives: [] },
  {
    id: "L0108",
    name: "Cappella S. Marie de Mascarella (Mascharella)",
    alternatives: [],
  },
  { id: "L0109", name: "Cappella S. Marie de Muradellis", alternatives: [] },
  { id: "L0110", name: "Cappella S. Marie de Oxilittis", alternatives: [] },
  {
    id: "L0111",
    name: "Cappella S. Marie porte Ravennatis (Ravignane)",
    alternatives: [],
  },
  { id: "L0112", name: "Cappella S. Marie de Turlionibus", alternatives: [] },
  {
    id: "L0114",
    name: "Cappella S. Martini de Aposa (Apposa, Apoxa, Apaxa)",
    alternatives: [],
  },
  {
    id: "L0119",
    name: "Cappella S. Michaelis de Foro Medii",
    alternatives: [],
  },
  { id: "L0121", name: "Cappella S. Nicholay de Albaris", alternatives: [] },
  {
    id: "L0122",
    name: "Cappella S. Nicholay burgi S. Felicis",
    alternatives: [],
  },
  { id: "L0125", name: "Cappella S. Proculi", alternatives: [] },
  { id: "L0126", name: "Cappella S. Prosperi", alternatives: [] },
  { id: "L0127", name: "Cappella S. Senixii (Senexii)", alternatives: [] },
  { id: "L0128", name: "Cappella S. Symonis et Iude", alternatives: [] },
  {
    id: "L0131",
    name: "Cappella S. Stephani (Stephany, Stepani)",
    alternatives: [],
  },
  {
    id: "L0132",
    name: "Cappella S. Tecle strate S. Stephani",
    alternatives: [],
  },
  { id: "L0134", name: "Cappella S. Tecle de Lambertaciis", alternatives: [] },
  {
    id: "L0135",
    name: "Cappella S. Thome (Thomacis) de Mercato (Merchato)",
    alternatives: [],
  },
  { id: "L0137", name: "Cappella S. Vitalis", alternatives: [] },
  { id: "L0138", name: "Cappella S. Vitis", alternatives: [] },
  { id: "L0151", name: "Contrata Blanchorum de Lunixana", alternatives: [] },
  { id: "L0154", name: "Contrata S. Dominici", alternatives: [] },
  { id: "L0160", name: "Conventus ff. Minorum", alternatives: [] },
  { id: "L0161", name: "Conventus ff. Predicatorum", alternatives: [] },
  { id: "L0168", name: "Districtus Bononie", alternatives: [] },
  {
    id: "L0188",
    name: "Ecclesia S. Anthoni de strata S. Vitalis",
    alternatives: [],
  },
  { id: "L0217", name: "Forum Medii", alternatives: [] },
  { id: "L0227", name: "hospitale S. Stephani", alternatives: [] },
  { id: "L0238", name: "Monasterium S. Felicis", alternatives: [] },
  {
    id: "L0253",
    name: "Porta Ravennatis (Ravennata, Ravignana)",
    alternatives: [],
  },
  { id: "L0260", name: "Saragoça (Sarragocia, Saragocia)", alternatives: [] },
  {
    id: "L0267",
    name: "Strata Castillionis (Chastileonis, Castilionis)",
    alternatives: [],
  },
  { id: "L0269", name: "Strata Maior", alternatives: [] },
  { id: "L0272", name: "Strata S. Stephani", alternatives: [] },
  { id: "L0273", name: "Strata S. Vitalis", alternatives: [] },
  { id: "L0281", name: "Valdescura", alternatives: [] },
  { id: "L0289", name: "Burgo Panichalis", alternatives: [] },
  { id: "L0294", name: "Heremitorium", alternatives: [] },
  { id: "L0309", name: "Campagnola, diocesis Regini", alternatives: [] },
  {
    id: "L0329",
    name: "Castri Veteris, Mutinensis diocesis, curia terre; terra",
    alternatives: [],
  },
  { id: "L0335", name: "Castrum S. Petri; burgus", alternatives: [] },
  { id: "L0343", name: "Centi, plebs", alternatives: [] },
  { id: "L0349", name: "Clavassio, de, Montis Ferrati", alternatives: [] },
  { id: "L0366", name: "Ecclesia S. Salvatoris", alternatives: [] },
  {
    id: "L0372",
    name: "Duraço, ecclesia S. Marie de; terra",
    alternatives: [],
  },
  { id: "L0377", name: "Feraria (Ferraria)", alternatives: [] },
  { id: "L0379", name: "Castrum Tealdi (Thealdi)", alternatives: [] },
  { id: "L0385", name: "Contrata S. Vitalis", alternatives: [] },
  { id: "L0438", name: "Lirano, de, Mutinensis diocesis", alternatives: [] },
  {
    id: "L0480",
    name: "Mongiorgio",
    alternatives: [
      "Monçorgio",
      "Mongorgio",
      "Monçorço",
      "Monçorçio",
      "Moncorgio",
      "Monçorgni",
      "Monzorgio",
    ],
  },
  {
    id: "L0483",
    name: "Mongiorgio; terra",
    alternatives: [
      "Monçorgio",
      "Mongorgio",
      "Monçorço",
      "Monçorçio",
      "Moncorgio",
      "Monçorgni",
      "Monzorgio",
    ],
  },
  { id: "L0500", name: "Monte Armato (Montarmato)", alternatives: [] },
  {
    id: "L0502",
    name: "Monte Armato: Monasterium S. Marie de",
    alternatives: [],
  },
  {
    id: "L0503",
    name: "Montebellio (Montebello, Montebelio)",
    alternatives: [],
  },
  { id: "L0511", name: "Plebs S. Marie de", alternatives: [] },
  {
    id: "L0514",
    name: "Monte Chalvo (Chalvuli, Chalbulli, Calbulli), de, Mutinensis diocesis",
    alternatives: [],
  },
  {
    id: "L0517",
    name: "Monte Marvo (Marii, Marvi), de, Bononiensis diocesis",
    alternatives: [],
  },
  {
    id: "L0524",
    name: "Monte Umbrario (Umbraro, Ombrario, Montonbrario), de, Mutinensis diocesis",
    alternatives: [],
  },
  { id: "L0530", name: "Mutina", alternatives: [] },
  { id: "L0539", name: "Diocesis Mutinensis", alternatives: [] },
  { id: "L0540", name: "Districtus Mutinensis", alternatives: [] },
  { id: "L0549", name: "Muxello (Musello), de", alternatives: [] },
  { id: "L0557", name: "Padua", alternatives: [] },
  { id: "L0580", name: "Plumatium (Plumacium)", alternatives: [] },
  {
    id: "L0585",
    name: "Plumatium (Plumacium): Burgo S. Marchi, in",
    alternatives: [],
  },
  { id: "L0587", name: "Castrum", alternatives: [] },
  { id: "L0605", name: "Regium", alternatives: [] },
  { id: "L0630", name: "Rodiiano, de; terra", alternatives: [] },
  { id: "L0641", name: "Rovoretulum, iuxta Bononiam; terra", alternatives: [] },
  { id: "L0649", name: "Terra Samodie (Samoçe, Samogie)", alternatives: [] },
  {
    id: "L0657",
    name: "Sancti Apolonaris, conventus, Bononiensis diocesis",
    alternatives: [],
  },
  { id: "L0659", name: "Sancta Ellena (Helena)", alternatives: [] },
  {
    id: "L0666",
    name: "Sancta Ellena (Helena): Conventus ff. Servorum S. Marie",
    alternatives: [],
  },
  { id: "L0669", name: "Monasterium S. Helene", alternatives: [] },
  {
    id: "L0678",
    name: "Sanctus Martinus in Argele (Arçele)",
    alternatives: [],
  },
  {
    id: "L0680",
    name: "Sanctus Martinus in Argele (Arçele); terra",
    alternatives: [],
  },
  { id: "L0692", name: "Sassoli", alternatives: [] },
  { id: "L0695", name: "Sassoli: Hospitale", alternatives: [] },
  {
    id: "L0707",
    name: "Solignano (Solegnano), de, Mutinensis diocesis; terra",
    alternatives: [],
  },
  { id: "L0735", name: "Verona, de", alternatives: [] },
  { id: "L0739", name: "Vetrana; terra", alternatives: [] },
  {
    id: "L0133",
    name: "Cappella S. Tecle de Curia di porta Nuova",
    alternatives: [],
  },
  { id: "L0120", name: "Cappella S. Michaelis de Lobraxeto", alternatives: [] },
  { id: "L0060", name: "Cappella S. Ambrosii", alternatives: [] },
  { id: "L0113", name: "Cappella S. Marini", alternatives: [] },
  { id: "L0103", name: "Cappella S. Marie de Claviga", alternatives: [] },
  { id: "L0100", name: "Cappella S. Marie de Carariis", alternatives: [] },
  { id: "L0091", name: "Cappella S. Iuliani", alternatives: [] },
  { id: "L0064", name: "Cappella S. Archangeli", alternatives: [] },
  { id: "L0065", name: "Cappella S. Barbatiani", alternatives: [] },
  { id: "L0090", name: "Cappella S. Ysaye", alternatives: [] },
  { id: "L0083", name: "Cappella S. Felicis", alternatives: [] },
  { id: "L0072", name: "Cappella S. Cervasii (Cervaxii)", alternatives: [] },
  { id: "L0061", name: "Cappella S. Andree de Ansaldis", alternatives: [] },
  { id: "L0062", name: "Cappella S. Andree de Platixiis", alternatives: [] },
  { id: "L0082", name: "Cappella S. Fabiani", alternatives: [] },
  { id: "L0092", name: "Cappella S. Laurentii de Guarinis", alternatives: [] },
  { id: "L0086", name: "Cappella S. Iacobi de Platixiis", alternatives: [] },
  {
    id: "L0211",
    name: "Ecclesia S. (beati) Petri (maior S. Petri)",
    alternatives: [],
  },
  {
    id: "L0115",
    name: "Cappella S. Martini de Aposa (Apposa, Apoxa, Apaxa), de",
    alternatives: [],
  },
  {
    id: "L0095",
    name: "Capella S. Lucie (Luçie) strate Castillionis",
    alternatives: [],
  },
  { id: "L0073", name: "Cappella S. Christine de Fondatia", alternatives: [] },
  { id: "L0076", name: "Capella S. Columbani", alternatives: [] },
  { id: "L0130", name: "Cappella S. Syrri", alternatives: [] },
  {
    id: "L0067",
    name: "Cappella S. Benedicti de Pavanensibus (de porta Nova)",
    alternatives: [],
  },
  {
    id: "L0098",
    name: "Cappella S. Marie de Baroncella (Baronçella)",
    alternatives: [],
  },
  { id: "L0074", name: "Cappella S. Christofori", alternatives: [] },
  { id: "L0104", name: "Cappella S. Marie de Fossole", alternatives: [] },
  {
    id: "L0752",
    name: "Zapolino (Çapolino, Zappulino); terra",
    alternatives: [],
  },
  { id: "L0129", name: "Cappella S. Symonis de Machagnanis", alternatives: [] },
  {
    id: "L0136",
    name: "Cappella S. Thome de Strata Maiori (Strate Maioris)",
    alternatives: [],
  },
];
